import { Validators, } from '@angular/forms';
import UiValidators from '@validators';
export var InputType;
(function (InputType) {
    InputType[InputType["Number"] = 0] = "Number";
    InputType[InputType["Boolean"] = 1] = "Boolean";
    InputType[InputType["String"] = 2] = "String";
    InputType[InputType["Complex"] = 3] = "Complex";
})(InputType || (InputType = {}));
var Definitions;
(function (Definitions) {
    Definitions.decimalNumber = function (min, max) { return ({
        type: InputType.Number,
        validator: function (c) {
            if (c.value == null ||
                c.value === '') {
                return null;
            }
            var value = Number(c.value);
            return !Number.isNaN(value) ?
                UiValidators.range(min, max)(c) : {
                decimalNumber: true,
            };
        },
        restriction: /^[-0-9.]+$/,
    }); };
    Definitions.bool = function () { return ({
        type: InputType.Boolean,
        validator: function () { return null; },
    }); };
    Definitions.wholeNumber = function (min, max) { return ({
        type: InputType.Number,
        validator: function (c) {
            if (c.value == null ||
                c.value === '') {
                return null;
            }
            var value = Number(c.value);
            return !Number.isNaN(value) ?
                UiValidators.range(min, max)(c) : {
                wholeNumber: true,
            };
        },
        restriction: /^[-0-9]+$/,
    }); };
    Definitions.string = function (max) { return ({
        type: InputType.String,
        validator: function (c) {
            return Validators.maxLength(max)(c);
        },
    }); };
})(Definitions || (Definitions = {}));
export var ClrType;
(function (ClrType) {
    var regex = {
        namespace: '^([\\w.]+)',
        name: '(\\.)(\\w+)',
        genericSeparator: '(`)',
        genericArgumentCount: '(\\d)',
        genericArgumentTypes: '(\\[)(.+)(\\])',
        arraySuffix: /(\[\])*$/,
        extendedInfo: /, [0-9a-zA-Z\.]+, Version=[0-9a-z\.]+, Culture=[0-9a-zA-Z\.]+, PublicKeyToken=[a-f0-9]+/g,
        clrType: function () {
            var nonGenericType = "" + regex.namespace + regex.name;
            var genericType = "" + nonGenericType + regex.genericSeparator + regex.genericArgumentCount + regex.genericArgumentTypes;
            return new RegExp(genericType + "|" + nonGenericType);
        },
    };
    var PrimitiveType;
    (function (PrimitiveType) {
        PrimitiveType["bool"] = "System.Boolean";
        PrimitiveType["byte"] = "System.Byte";
        PrimitiveType["sbyte"] = "System.SByte";
        PrimitiveType["char"] = "System.Char";
        PrimitiveType["double"] = "System.Double";
        PrimitiveType["float"] = "System.Single";
        PrimitiveType["int"] = "System.Int32";
        PrimitiveType["uint"] = "System.UInt32";
        PrimitiveType["long"] = "System.Int64";
        PrimitiveType["ulong"] = "System.UInt64";
        PrimitiveType["short"] = "System.Int16";
        PrimitiveType["ushort"] = "System.UInt16";
        PrimitiveType["string"] = "System.String";
    })(PrimitiveType = ClrType.PrimitiveType || (ClrType.PrimitiveType = {}));
    var DateType;
    (function (DateType) {
        DateType["dateTime"] = "System.DateTime";
        DateType["dateTimeOffset"] = "System.DateTimeOffset";
    })(DateType = ClrType.DateType || (ClrType.DateType = {}));
    var ComplexType;
    (function (ComplexType) {
        ComplexType["object"] = "System.Object";
    })(ComplexType = ClrType.ComplexType || (ClrType.ComplexType = {}));
    var parseGenericTypeList = function (types, cb) {
        var genericTypeRaw = types[1];
        var subGroupDelimiters = [];
        var level = 0;
        // determine the first level type groups
        genericTypeRaw.split('')
            .forEach(function (ch, idx) {
            if (ch === '[') {
                level += 1;
            }
            if (ch === ']') {
                level -= 1;
            }
            if (level === 0 &&
                ch === ',') {
                subGroupDelimiters.push(idx);
            }
        });
        // add the last subgroup index
        subGroupDelimiters.push(genericTypeRaw.length);
        for (var i = 0; i < subGroupDelimiters.length; i += 1) {
            var previousIndex = i ? subGroupDelimiters[i - 1] : -1;
            // display start and end indices
            // in order to remove extra commas and extra parenthesis
            var group = genericTypeRaw.substring(previousIndex + 2, subGroupDelimiters[i] - 1);
            cb(group);
        }
    };
    ClrType.parseType = function (clrType) {
        var _a, _b;
        var cleanType = clrType.replace(regex.extendedInfo, '');
        var clrNamespace, separator, name, countSeparator, count, types, arraySuffix;
        try {
            // extract array multi-dimensional suffix
            arraySuffix = cleanType.match(regex.arraySuffix)[0];
            // clean array suffix from parsed type
            cleanType = cleanType.replace(regex.arraySuffix, '');
            _a = regex.clrType()
                .exec(cleanType)
                .filter(function (m) { return !!m; }), clrNamespace = _a[1], separator = _a[2], name = _a[3], countSeparator = _a[4], count = _a[5], types = _a.slice(6);
        }
        catch (_c) {
            // use 'System.Object' as a fallback if something goes wrong (unknown library / version)
            _b = regex.clrType()
                .exec(ClrType.ComplexType.object)
                .filter(function (m) { return !!m; }), clrNamespace = _b[1], separator = _b[2], name = _b[3], countSeparator = _b[4], count = _b[5], types = _b.slice(6);
        }
        var isGeneric = countSeparator === '`';
        var type = {
            type: clrType,
            namespace: clrNamespace,
            fullName: "" + clrNamespace + separator + name,
            display: name + arraySuffix,
            name: name,
            isGeneric: isGeneric,
            arguments: {
                count: isGeneric ? Number(count) : 0,
                list: [],
            },
        };
        if (type.isGeneric) {
            parseGenericTypeList(types, function (group) { return type.arguments.list.push(ClrType.parseType(group)); });
            type.display = type.name + "<" + type.arguments.list
                .map(function (t) { return t.display; })
                .join(', ') + ">" + arraySuffix;
        }
        return type;
    };
    ClrType.inputConfiguration = function (clrType) {
        var type = (clrType || '')
            .split(',')[0];
        switch (type) {
            case ClrType.PrimitiveType.bool:
                return Definitions.bool();
            case ClrType.PrimitiveType.byte:
                return Definitions.wholeNumber(0, 255);
            case ClrType.PrimitiveType.sbyte:
                return Definitions.wholeNumber(-128, 127);
            case ClrType.PrimitiveType.int:
                return Definitions.wholeNumber(-2147483648, 2147483647);
            case ClrType.PrimitiveType.uint:
                return Definitions.wholeNumber(0, 4294967295);
            case ClrType.PrimitiveType.long:
                return Definitions.wholeNumber(Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER);
            case ClrType.PrimitiveType.ulong:
                return Definitions.wholeNumber(0, Number.MAX_SAFE_INTEGER);
            case ClrType.PrimitiveType.short:
                return Definitions.wholeNumber(-32768, 32767);
            case ClrType.PrimitiveType.ushort:
                return Definitions.wholeNumber(0, 65535);
            case ClrType.PrimitiveType.char:
                return Definitions.string(1);
            case ClrType.PrimitiveType.string:
                return Definitions.string(2000);
            case ClrType.PrimitiveType.double:
            case ClrType.PrimitiveType.float:
                return Definitions.decimalNumber(Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER);
            case ClrType.DateType.dateTime:
            case ClrType.DateType.dateTimeOffset:
            default:
                return {
                    type: InputType.Complex,
                    validator: function (c) {
                        if (c.value == null ||
                            (typeof c.value === 'string' && !c.value)) {
                            return null;
                        }
                        try {
                            JSON.parse(c.value);
                            return null;
                        }
                        catch (_a) {
                            return {
                                json: true,
                            };
                        }
                    },
                };
        }
    };
})(ClrType || (ClrType = {}));
